import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import BaseIcon from "../../components/BaseIcon";
import { MODAL_TYPES } from "../../utils/emitter";
import PersonalAccount from "../../store/PersonalAccount";
import { buildShareLink, shareApp } from "../../utils/share";
import "./style.scss";

// «Тебе не хватает баллов» (дизайн Figma): текст + кнопка «Поделиться» реф-ссылкой.
export default observer(function NotEnoughPointsModal() {
  const { t } = useTranslation();

  const share = async () => {
    await shareApp({
      url: buildShareLink(PersonalAccount.user?.refCode),
      text: t("share.invite_text"),
      sentryTag: "NotEnoughPointsModal",
    });
  };

  return (
    <BaseModal
      className="not-enough-points-modal"
      eventTypeModal={MODAL_TYPES.NOT_ENOUGH_POINTS}
      title={t("loyalty.not_enough.title")}
      description={t("loyalty.not_enough.text")}
    >
      <BaseButton onClick={share} className="not-enough-points-modal__share-btn">
        <BaseIcon
          name="share_gradient_white"
          className="not-enough-points-modal__share-icon"
        />
        {t("loyalty.not_enough.share_btn")}
      </BaseButton>
    </BaseModal>
  );
});
